import { faPhone } from '@fortawesome/pro-regular-svg-icons/faPhone';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { AgentResult } from '@propertypal/shared/src/types/agents';
import useCallAgent from '@propertypal/web-app/src/utils/useCallAgent';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import Button from '../buttons/Button';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Container, TextContent, CheckCircle } from './AgentCheckRow.style';
import AgentLogo from './AgentLogo';

interface Props {
  agent: AgentResult;
  checked: boolean;
  onCheckClick: (agent: AgentResult) => void;
}

const AgentCheckRow: FunctionComponent<Props> = (props) => {
  const { agent } = props;
  const theme = useTheme();
  const { phoneNumber, revealAgentNumber } = useCallAgent();

  return (
    <Container>
      <AgentLogo
        containerStyle={{ flex: '0 0 80px' }}
        size={80}
        image={agent.account.logo?.standard}
        color={agent.account.logo?.standardBackgroundColour}
      />

      <TextContent>
        {props.agent.account.featuredAgent && <p>Featured Agent</p>}

        <h3>
          <Link href={agent.url}>
            {agent.account.organisation} {agent.account.organisationBranch && `(${agent.account.organisationBranch})`}
          </Link>
        </h3>

        <p>{agent.account.displayAddress}</p>

        {!phoneNumber && (
          <Button icon={faPhone} onClick={() => revealAgentNumber(agent.account, 'Find an Agent')}>
            Call Agent
          </Button>
        )}

        {phoneNumber && (
          <a href={`tel:${phoneNumber}`}>
            <Button icon={faPhone}>{phoneNumber}</Button>
          </a>
        )}
      </TextContent>

      <CheckCircle
        $checked={props.checked}
        onClick={() => props.onCheckClick(agent)}
        type="button"
        data-testid="agent-checkbox"
      >
        {props.checked && <FontAwesomeIcon icon={faCheck} color={theme.white} size={14} />}
      </CheckCircle>
    </Container>
  );
};

export default AgentCheckRow;
